import { Box, styled } from "@mui/material";
import SocketNotification from "SocketsNotification/SocketNotification";
import { FC, Fragment, useState } from "react";
import { Outlet } from "react-router-dom";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSideBar";

// styled components
const Wrapper = styled(Box)(({ theme }) => ({
  width: `80%`,
  // maxWidth: 1200, remove to elongate the webpage  by ashar
  margin: "auto",
  paddingLeft: 80,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginLeft: 0,
    paddingLeft: "2rem",
    paddingRight: "2rem",
  },
}));

const DashboardLayout: FC = ({ children }) => {
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  return (
    <Fragment>
      <div style={{ width: "20%" }}>
        <DashboardSidebar
          showMobileSideBar={showMobileSideBar}
          closeMobileSideBar={() => setShowMobileSideBar(false)}
        />
      </div>

      <Wrapper>
        <DashboardNavbar
          setShowMobileSideBar={() => setShowMobileSideBar((state) => !state)}
        />
        {children || <Outlet />}
      </Wrapper>
      <SocketNotification />
    </Fragment>
  );
};

export default DashboardLayout;
